"use client";

import HcpAccordion from '@/components-hcp/accordion';
import CustomImage from '@/components/image';
import styles from './_metabolic-health.module.scss';

export default function HcpClinicalInformationMetabolicHealth() {
  return (
    <section className={styles.metabolic}>
      <HcpAccordion
        label={<>View BMI and metabolic health data</>}
      >
        <div className={`container ${styles.metabolic_container}`}>
          <div className={styles.metabolic_heading}>Enduring improvements in metabolic health</div>
          <div className={styles.metabolic_grid}>
            <div className={styles.metabolic_col}>
              <div className={styles.metabolic_data_title}>BMI standard deviation (mean change from baseline)<sup>6,12</sup><span className="super-asterisc">*</span><sup>&dagger;</sup></div>
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcSet="/images/page/hcp/clinical-information/Clinical-Information_Pediatric-BMI-Standard-Deviation_mobile.svg"
                  width={327}
                  height={1363}
                />
                <CustomImage
                  src='/images/page/hcp/clinical-information/Clinical-Information_Pediatric-BMI-Standard-Deviation.svg'
                  width={593}
                  height={605}
                  alt='Mean BMI standard deviation was reduced by 0.09 in children taking CRENESSITY vs a 0.04 increase with placebo.'/>
              </picture>
              <div className="hcp-callout">
                <span>Among children who were overweight or obese at baseline, 60% achieved &ge;0.2 reduction in BMI SDS at 2 years.<sup>6</sup>
                </span>
              </div>
            </div>
            <div className={styles.metabolic_col}>
              <div className={styles.metabolic_data_title}>HOMA-IR (mean change from baseline)<sup>6,12&dagger;&Dagger;</sup></div>
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcSet="/images/page/hcp/clinical-information/Clinical-Information_Pediatric-HOMA-IR_mobile.svg"
                  width={327}
                  height={1644}
                />
                <CustomImage
                  src='/images/page/hcp/clinical-information/Clinical-Information_Pediatric-HOMA-IR.svg'
                  width={593}
                  height={605}
                  alt='HOMA-IR was reduced by 0.5 in children taking CRENESSITY vs a 0.03 increase with placebo.'/>
              </picture>
              <div className="hcp-callout">
                <span>
                  At 2 years, 61% of children who were insulin resistant at baseline no longer met the criteria for insulin resistance.<sup>6</sup>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="container container--constraint">
          <div className={styles.purpleText}>
            <p>These secondary and prespecified exploratory endpoints were not adjusted for multiplicity; these descriptive results could represent chance findings.<sup>1,9,12,13</sup></p>
          </div>
          <ul className={`footnotes`}>
            <li>
              <span className="hang">*</span>
              <span>Mean baseline values for BMI standard deviation were 1.1 ± 1.0 for placebo and 1.2 ± 0.9 for CRENESSITY.<sup>9</sup></span>
            </li>
            <li>
              <sup className="hang">&dagger;</sup>
              <span>The 2-year timepoint includes pediatric patients treated with CRENESSITY for 24 months, as well as patients who started taking placebo and switched to CRENESSITY at month 7 (ie, patients treated with CRENESSITY for 17 months).<sup>11</sup></span>
            </li>
            <li>
              <sup className="hang">&Dagger;</sup>
              <span>Mean baseline values for HOMA-IR were 3.34 ± 3.43 for placebo and 2.79 ± 1.64 for CRENESSITY.<sup>8</sup></span>
            </li>
            <li>
              <span>BMI=body mass index; HOMA-IR=homeostatic model assessment for insulin resistance; SDS=standard deviation score.</span>
            </li>
          </ul>
        </div>
      </HcpAccordion>
    </section>
  );
}
